import * as aor from "react-admin";
import React from "react";
import CardActions from "@material-ui/core/CardActions";
import CustomerMappingGrid from "../../components/CustomerMappingGrid";
import { Field } from "redux-form";
import { POLICY_CUSTOMERS_MAPPINGS } from "../../common/rolesManagement";
import { getPolicies } from "../../common/authClient";
import DeleteButton from "../../components/DeleteButton";
import { POLICY_CUSTOMERS } from "../../common/rolesManagement";
import { getUserCompany } from "../../common/authClient";

const Actions = ({ permissions, basePath, data }) => {
    if (data) {
        return (
            <CardActions
                style={{ zIndex: 2, display: "inline-block", float: "right" }}
            >
                <aor.ShowButton basePath={basePath} record={data} />
                {data.id !== parseInt(getUserCompany, 10) &&
                    permissions &&
                    permissions.includes(POLICY_CUSTOMERS.DELETE) && (
                        <DeleteButton
                            undoable={true}
                            basePath={basePath}
                            record={data}
                            dialogContentTitle="resources.customers.actions.delete"
                            text="resources.customers.actions.delete"
                            resource="customers"
                            message={"Cancellazione effettuata"}
                            redirect={"customers"}
                        />
                    )}
                <aor.ListButton basePath={basePath} />
            </CardActions>
        );
    } else {
        return null;
    }
};

const MyToolbar = props => {
    return (
        <aor.Toolbar {...props}>
            <aor.SaveButton redirect="show" submitOnEnter={true} />
        </aor.Toolbar>
    );
};

export default props => (
    <aor.Edit
        {...props}
        undoable={false}
        title={"resources.customers.nameSingular"}
        actions={<Actions permissions={getPolicies()} />}
    >
        <aor.SimpleForm toolbar={<MyToolbar />} redirect="show">
            <aor.TextField source="vatin" />
            <aor.TextInput source="name" validate={[aor.required()]} />
            <aor.TextInput
                source="email"
                validate={[aor.required(), aor.email()]}
            />
            {(getPolicies().includes(POLICY_CUSTOMERS_MAPPINGS.UPDATE) ||
                getPolicies().includes(
                    POLICY_CUSTOMERS_MAPPINGS.SAFE_UPDATE
                )) && (
                <div style={{ width: "100%" }}>
                    <Field
                        validate={aor.required()}
                        name="company_ids"
                        type="select-multi"
                        component={CustomerMappingGrid}
                        {...{
                            basePath: props.basePath,
                            resource: "customers-mappings",
                            resourceId: props.id
                        }}
                    />
                </div>
            )}
        </aor.SimpleForm>
    </aor.Edit>
);



// WEBPACK FOOTER //
// ./src/resources/Customers/Edit.js